
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { Prop } from "vue-property-decorator";

@Component({
  components: {},
  filters,
})
export default class CourseAssessmentCheckbox extends Vue {
  @Prop({ default: null })
  private question!: any;
  @Prop({ default: 0 })
  private questionIndex!: number;
}
